import React, { PureComponent } from 'react';
import { AddTestDialog } from '../coursePlan/addTestDialog';

interface ComboAndStandardTestProps {
  test?: any;
  packageData?: any;
  match?: any;
  isEmpty?: boolean;
  isConflict?: boolean;
  phase: any;
  fromCombo?: boolean;
  open: boolean;
  handleToggleOpen: Function;
  handleComboSaveTest: Function;
  editMode: boolean;
  editTestDetails: any;
  coursePlanId?: string;
  testIndex?:number;
  handleDeleteTestFromComboCourse?: Function;
  mappedTest: string;
  courseId: string;
  testType: string;
  testDurationFromAPI: number;
  questionsCountFromAPI: number;
  phaseIndex: number;
  packageEndDate: string | Date;
  isExtraTests?: boolean;
}
interface ComboAndStandardTestState {
  addTestDialogProps: any;
  courseDetails: {};
}
class ComboAndStandardTest extends PureComponent<ComboAndStandardTestProps, ComboAndStandardTestState> {
  constructor(props: ComboAndStandardTestProps) {
    super(props);
    this.state = {
      addTestDialogProps: {
        title: 'Add Test',
        dropDownStringArray: this.props.fromCombo ? ['Select goal'] : ['test'],
        textFieldStringArray: [
          { title: 'Test Name', name: 'testName', value: 'displayName' },
          {
            title: 'Test Syllabus',
            name: 'testSyllabus',
            value: 'paperDetail.syllabus.text',
          },
        ],
        dialogButtonName: 'Add test',
        isExistingTest: true,
        durationAttemptRevision: [
          { title: 'Duration', name: 'duration', value: 'duration' },
          { title: 'Max Attempt', name: 'maxAttempt', value: 'maxAttempt' },
          {
            title: 'Questions Count',
            name: 'questionsCount',
            value: 'questionsCount',
            // placeholder: 'Enter questions count'
          },
          {
            title: 'Block Revision Time for This Test',
            name: 'blockRevisionTime',
            value: 'blockRevisionTime',
          },
        ],
        buttonName: '+ Add Test',
        isRequiredMapTest: true,
        isExistingAndScheduledTest: true,
        isRequiredDate: true,
      },
      courseDetails: {},
    };
  }

  render = () => {
    const { addTestDialogProps } = this.state;
    const { open, handleToggleOpen, mappedTest, courseId, testType, phaseIndex, packageEndDate, isExtraTests, testDurationFromAPI, questionsCountFromAPI  } = this.props;
    return (
      <div>
        <AddTestDialog
          open={open}
          handleToggleOpen={handleToggleOpen}
          title={addTestDialogProps.title}
          dropDownStringArray={addTestDialogProps.dropDownStringArray}
          textFieldStringArray={addTestDialogProps.textFieldStringArray}
          dialogButtonName={addTestDialogProps.dialogButtonName}
          isExistingTest={addTestDialogProps.isExistingTest}
          durationAttemptRevision={addTestDialogProps.durationAttemptRevision}
          buttonName={addTestDialogProps.buttonName}
          isRequiredMapTest={addTestDialogProps.isRequiredMapTest}
          isExistingAndScheduledTest={addTestDialogProps.isExistingAndScheduledTest}
          isRequiredDate={addTestDialogProps.isRequiredDate}
          courseId={this.props.match && this.props.match.params.id}
          courseIdData = {courseId}
          courseDetails={this.state.courseDetails}
          fromCombo={this.props.fromCombo}
          onSaveCombo={this.props.handleComboSaveTest}
          editMode={this.props.editMode}
          editTestDetails={this.props.editTestDetails}
          coursePlanId={this.props.coursePlanId}
          testIndex={this.props.testIndex}
          phase={this.props.phase}
          handleDeleteTestFromComboCourse={this.props.handleDeleteTestFromComboCourse}
          mappedTest={mappedTest}
          testType={testType}
          test={this.props.test}
          testDurationFromAPI = {testDurationFromAPI}
          questionsCountFromAPI={questionsCountFromAPI}
          phaseIndex={phaseIndex}
          packageEndDate={packageEndDate}
          isExtraTests={isExtraTests}
        />
      </div>
    );
  };
}

export default ComboAndStandardTest;
